import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEmail = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 5.25a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75zm17.25 1.804V6.75H3.75v.304l7.786 5.423c.114.08.279.135.464.135s.35-.055.464-.135zM3.75 8.882v8.368h16.5V8.882l-6.928 4.826a2.3 2.3 0 0 1-1.322.404 2.3 2.3 0 0 1-1.322-.404z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgEmail;
